import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// env
import { environment } from './../../../../environments/environment';

// Service
import { ApiService } from '../../../shared/service/api.service';
import { GlobalService } from '../../../shared/service/global.service';

// Plugin
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-committee',
  templateUrl: './committee.component.html',
  styles: [
  ]
})
export class CommitteeComponent implements OnInit {

  @ViewChild('autoShownModal', { static: false }) autoShownModal: ModalDirective;
  isModalShown = false;
  apiAsset = environment.API_ASSETS;
  modalImg: string;
  modalDetail: string;
  modalName: string;
  modalPosition: string;
  dataTitle;
  dataSection = [];
  dataAudit;
  dataRemunerasi;
  dataRisk;

  constructor(private apiService: ApiService, 
              private globalService: GlobalService,
              private router: Router) {
     this.globalService.isLoading.next(true); 
  }

  ngOnInit(): void {
    // Content
    this.apiService.getDataApi('getMenuSection/committee').subscribe(response => {
      if(response.success) {
        this.dataTitle = response.data;
        this.dataSection = response.data.section;;
        // Meta
        this.globalService.updateMeta(
          response.data.title + ' | Prime Agri Resources',
          response.data.keyword,
          response.data.metadesc
        );
        this.globalService.isLoading.next(false);
      } else {
        this.router.navigate(['/not-found']);
      }
    });

    // directors
    this.apiService.getDataApi('getDirector?category=7').subscribe(response => {
        this.dataAudit = response.data.content;
    });
    this.apiService.getDataApi('getDirector?category=6').subscribe(response => {
        this.dataRemunerasi = response.data.content;
    });
    this.apiService.getDataApi('getDirector?category=8').subscribe(response => {
        this.dataRisk = response.data.content;
    });
  }

  showModal(people): void {
    this.isModalShown = true;
    this.modalDetail = people.description;
    this.modalImg = people.picture;
    this.modalPosition = people.position;
    this.modalName = people.fullname;
  }
 
  hideModal(): void {
    this.autoShownModal.hide();
  }
 
  onHidden(): void {
    this.isModalShown = false;
  }

}
